export default function reducer(
  state = {
    brands: '',
  },
  action
) {
  switch (action.type) {
    case 'GET_BRANDS_LIST_STARTED': {
      return { ...state, changingStatus: 'ongoing' };
    }
    case 'GET_BRANDS_LIST_SUCCESS': {
      return {
        ...state,
        changingStatus: 'success',
        brands: action.payload,
      };
    }
    case 'GET_BRANDS_LIST_FAILED': {
      return {
        ...state,
        changingStatus: 'failed',
        brands: action.payload,
      };
    }
    default: {
      return state;
    }
  }
}
